import {Component, OnInit, Output, EventEmitter, Inject} from 'ng-metadata/core';
import {getInstitutionCode} from '../../../../appConfig/appConfigForward';

@Component({
    selector: 'prm-request-it-bookmark',
    templateUrl: 'components/search/topbar/userArea/requestItBookmark/request-it-bookmark.html',
})

export class RequestItBookmarkDirective implements OnInit {

    bookmarkUrl: string
    @Output() private onCancel = new EventEmitter();

    constructor(@Inject('$sce') private $sce: ng.ISCEService, @Inject('I18nService') private i18nService) {
        this.bookmarkUrl = this.sanitize(this.getBookmarkScriptUrl());
    }

    ngOnInit() {
    }

    getBookmarkScriptUrl() {
        return 'javascript:(function(){' +
            ' var jqv = 0;' +
            ' var jquiv = 0;' +
            ' if((typeof jQuery != "undefined") && (jQuery != null)){' +
            ' jqv = jQuery.fn.jquery;' +
            ' if(jQuery.ui != undefined) {' +
            ' jquiv = jQuery.ui.version;}}' +
            ' var i = document.createElement("script");' +
            ' var sc = "' + location.protocol + '//' + location.host +
            '/view/resourceSharingJSParser?url=" + encodeURIComponent(document.URL.split("?")[0]) +' +
            ' "&institute=' + getInstitutionCode() + "&lang=" +  this.i18nService.getLanguage() +
            '&auth=local' + '&jqv=" + encodeURIComponent(jqv) + "&jquiv=" + encodeURIComponent(jquiv);' +
            ' i.id = "jsAcquisitionParser";' +
            ' i.src = sc; ' +
            ' i.setAttribute("base","' + location.protocol + '//' + location.host + '");' +
            ' document.getElementsByTagName("BODY")[0].appendChild(i);' +
            ' })();';
    }

    sanitize(url: string) {
        return this.$sce.trustAsResourceUrl(url);
    }

    preventDefault($event) {
        $event.preventDefault();
    }

    public close() {
        this.onCancel.emit(null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/requestItBookmark/request-it-directive.ts